import Model, { attr } from '@warp-drive/legacy/model';
import type { Type } from '@warp-drive/core/types/symbols';
import type { EnumValue } from '@linc-technologies/linced-common/enums/base-enum';
import type Jurisdiction from '@linc-technologies/linced-common/enums/jurisdiction';

// Proto: cron.Task.
export default class Task extends Model {
  declare [Type]: 'cron/task';

  // createTime is when the resource was created in seconds from the epoch.
  @attr('number')
  declare createTime: number | undefined;

  // updateTime is the last time the resource was modified in seconds from
  // the epoch.
  @attr('number')
  declare updateTime: number | undefined;

  // jurisdiction is the educational jurisdiction this specific task is
  // registered to be run for.
  @attr('number', { defaultValue: 0 })
  declare jurisdiction: EnumValue<typeof Jurisdiction> | 0;

  // campusId is the school campus the task relates to.
  @attr('string', { defaultValue: '' })
  declare serviceName: string;

  // serviceTask is the service's unique scheduled task name.
  @attr('string', { defaultValue: '' })
  declare serviceTask: string;

  // crontab stores the crontab format string as to when the job should be
  // run.
  @attr('string', { defaultValue: '' })
  declare crontab: string;

  // enabled specifies whether the scheduled task is currently configured to
  // run.
  @attr('boolean', { defaultValue: false })
  declare enabled: boolean;

  // description provides a human-readable description to be displayed.
  @attr('string', { defaultValue: '' })
  declare description: string;
}
